import { FC } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import OpenLayersMap from '../openlayersmap/OpenLayersMap'
import store, { RootState } from '../../Store'
import { mainContentViewStyle } from './MainContentView.style'
import { ToolType } from 'src/Enums'
import { MapView3D } from '../mapview3d/MapView3D'
import { LayerType } from 'src/dataSources/layers/LayerRegistry'
import { wikiActions } from 'src/actions/WikiActions'
import { infoMenuActions } from 'src/actions/InfoMenuActions'

export interface MainContentViewProps { // eslint-disable-line @typescript-eslint/no-empty-interface
}

const defaultProps: MainContentViewProps = {
}

export const MainContentView: FC<MainContentViewProps> = (props: MainContentViewProps) => {
  const classes = mainContentViewStyle()
  const dispatch = useDispatch()
  const enabledLayers = useSelector((state: RootState): LayerType[] => state.mapState.enabledLayers)
  const selectedTool = useSelector((state: RootState): ToolType => state.generalState.selectedTool)

  const leftClickHandler = (coords: number[]): void => {
    // We need to fetch the current state using the store handle here,
    // because of the way the binding with useSelector is done.
    // Otherwise we get stale state information.
    const selectedTool = store.getState().generalState.selectedTool
    const enabledLayers = store.getState().mapState.enabledLayers

    switch (selectedTool) {
      case ToolType.INFO: {
        const boreholeLayerEnabled = enabledLayers.some(layerType => layerType === LayerType.BORE_HOLES)
        if (boreholeLayerEnabled) {
          dispatch(wikiActions.clearViews())
          dispatch(infoMenuActions.boreholeInfo(coords))
        }
        break
      }
      case ToolType.PROFILE:
        break
      case ToolType.VIRTUAL_BOREHOLE:
        dispatch(wikiActions.clearViews())
        dispatch(infoMenuActions.virtualBoreholeInfo(coords))
        break
    }
  }

  return (
    <div className={classes.root}>
      {selectedTool !== ToolType._3D_VIEW && (
        <OpenLayersMap layerTypes={enabledLayers} onLeftClick={leftClickHandler} />
      )}
      {selectedTool === ToolType._3D_VIEW && (
        <MapView3D />
      )}
    </div>
  )
}

MainContentView.defaultProps = defaultProps

export default MainContentView
